import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SendEmailToWritersPayload } from '../../../shared/models/payloads/email-communication.payload';

@Injectable({
  providedIn: 'root',
})
export class HttpEmailCommunicationService {
  constructor(private http: HttpClient) {}

  blockEmailNotifications(token: string) {
    return this.http.post(`${environment.api_base_url}/notifications/unsubscribe_from_all_emails`, {
      authToken: token,
    });
  }

  sendEmailToWriters(payload: SendEmailToWritersPayload) {
    return this.http.post(
      `${environment.api_base_url}/internal_email/send_message_to_writers`,
      payload
    );
  }
}
